/*
 * @Description:
 * @version:
 * @Author: linziying
 * @Date: 2019-08-19 16:33:37
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-12-10 15:05:17
 */
/*
 *   处理页面中所有的用到的请求
 * */
import Vue from 'vue';
import {commonFn} from './common';
import {wxConfig, pagePath} from '../../common/js/config';
import platform from './platform';
import {getOsVersion} from './utils.js';
import store from '../../vuex/index';

let env = process.env.NODE_ENV;
// 登录处理
window.yqwLogin = function (res) {
	// 清除登录标志
	sessionStorage.removeItem('login_times', 1);
	location.reload();
};
// 获取当前的平台
let isAndroid = window.mmc.client.isAndroid();
let loginHandle = () => {
	if (!sessionStorage.getItem('login_times')) {
		try {
			sessionStorage.setItem('login_times', 1);
		} catch (e) {}

		setTimeout(() => {
			sessionStorage.removeItem('login_times');
		}, 2000);
		localStorage.removeItem('yiQiWenToken');
		commonFn.removeCookieItem('_token', '/', 'yiqiwen.cn');
		if (commonFn.parseUA().wxMiniprogram) {
			return;
		}
		if (!commonFn.isH5()) {
			if (isAndroid) {
				window.mmc.user.login('window.yqwLogin');
			} else {
				window.mmc.user.login(function iosYqwLogin(res) {
					sessionStorage.removeItem('login_times', 1);
					location.reload();
				});
			}
		} else {
			// 如未登录
			// location.href = '/';
			if (location.pathname !== '/seckill') {
			}
		}
	}
};
// 公共的ajax处理函数
let ajaxResHandle = (data, resolve, reject, resBody, bj_options) => {
	let res = data.body;
	if (res.code == 1 || res.code == 200) {
		resolve(res.data);
	} else if (res.code == 1010) {
		store && store.commit('hideLoading');
		if (res.msg == '未登录') {
			store && store.commit('setUserIsLogin', false);
		}
		// 跳转登录
		reject(res.msg);
		localStorage.removeItem('yiQiWenToken');
		commonFn.removeCookieItem('_token', '/', 'yiqiwen.cn');
		// 未登录的话跳转至个人中心页面
		// if( location.pathname !== '/meIndex' ){
		// 	location.href = '/meIndex'
		// }
		// sessionStorage.removeItem('login_times');
		// setTimeout(loginHandle,10);
		loginHandle();
	} else if (res.code == 1009) {
		// 跳转至首页
		reject(res.msg);
		if (commonFn.parseUA().wxMiniprogram) {
			return;
		}
		location.href = '/';
		// try{
		// Vue.router.push({
		// 	path:'/'
		// })
		// }catch(err){
		// location.href = '/';
		// }
	} else if (res.code == 0 || res.code >= 10000) {
		reject(res.msg);
		errReport(res, resBody, bj_options);
	} else if (res.code == 1326 || res.code == 1025) {
		// 针对问题详情的处理，code=1326(问题被删除)，code=1025(没权限)
		reject(res);
	} else if (res.code == 2303) {
		reject(res);
	} else {
		reject(res.msg);
	}
};

// 接口请求失败上报
let errReport = (err, resBody = {}, reqData = {}) => {
	let {message, name, script, line, column, stack} = err;
	script = script !== undefined ? script : '';
	line = line !== undefined ? line : 0;
	column = column !== undefined ? line : 0;
	let stackStr = stack ? JSON.stringify(stack) : JSON.stringify(err);
	let errMsg = `request捕获到错误:${stackStr}`;
	if (env !== 'development') {
		try {
			let osVersion = getOsVersion();
			if (osVersion.indexOf('Android') > -1 && Number(osVersion.slice(7, 8)) < 6) {
				return;
			}
			BJ_REPORT.report({
				msg: errMsg,
				from: window.location.href,
				target: `resBody:${JSON.stringify(resBody)};options:${JSON.stringify(reqData)}`,
				rowNum: line,
				colNum: column
			});
		} catch (e) {
			console.log(e);
		}
	}
};

let myAjax = {
	get(api, data = {}, options = {needchannel: true}) {
		return new Promise((resolve, reject) => {
			console.log('123', data);
			let resBody = {};
			data.platform = data.platform || platform;
			// 重新设置一下platform
			if (commonFn.isLjds() && platform == '26') {
				data.platform = localStorage.getItem('platform') || '26';
			}
			Vue.http.headers.common['platform'] = data.platform + '';
			const channel = localStorage.getItem('channel') || '';
			if(options.needchannel){
				data.channel = data.channel ? data.channel : channel;
			}
			let bj_options = Object.assign({url: api}, data);
			Vue.http
				.get(api, {params: data, timeout: 30000, ...options})
				.then((data) => {
					resBody = data;
					ajaxResHandle(data, resolve, reject, resBody, bj_options);
				})
				.catch((err) => {
					reject(`数据获取失败,请刷新重试`);
					if (err.status !== undefined && err.status == 0) {
						// 用户取消发送，不上报错误
					} else {
						errReport(err, resBody, bj_options);
					}
				});
		});
	},
	post(api, data = {}, options = {}) {
		let resBody = {};
		data.platform = data.platform || platform;
		// 重新设置一下platform
		if (commonFn.isLjds() && platform == '26') {
			data.platform = localStorage.getItem('platform') || '26';
		}
		Vue.http.headers.common['platform'] = data.platform + '';
		const channel = localStorage.getItem('channel') || '';
		data.channel = data.channel ? data.channel : channel;
		let bj_options = Object.assign({url: api}, data);
		return new Promise((resolve, reject) => {
			Vue.http
				.post(api, data, Object.assign(options, {emulateJSON: true, timeout: 30000}))
				.then((data) => {
					resBody = data;
					ajaxResHandle(data, resolve, reject, resBody, bj_options);
				})
				.catch((err) => {
					reject(`数据获取失败,请刷新重试`);
					if (err.status !== undefined && err.status == 0) {
						// 用户取消发送，不上报错误
					} else {
						errReport(err, resBody, bj_options);
					}
				});
		});
	}
};
export default myAjax;



// WEBPACK FOOTER //
// ./src/common/js/request.js